<div class="panel-container" [ngClass]="{'ets-hidden': !isActive}">
<as-split class="collars-root" direction="vertical" [gutterSize]="5">

   <as-split-area [size]="sectionSizes.top">
      <as-split direction="horizontal" [gutterSize]="5">
         <as-split-area [size]="34">
            <ag-grid-angular class="ag-theme-balham-dark grid" [gridOptions]="portfoliosGrid"></ag-grid-angular>
         </as-split-area>
         <as-split-area [size]="33">
            <ag-grid-angular class="ag-theme-balham-dark grid" [gridOptions]="combosGrid"></ag-grid-angular>
         </as-split-area>
         <as-split-area [size]="33">
            <ag-grid-angular class="ag-theme-balham-dark grid" [gridOptions]="groupsGrid"></ag-grid-angular>
         </as-split-area>
      </as-split>
   </as-split-area>

   <as-split-area [size]="sectionSizes.bottom">
      <div class="bottom-area">
         <div class="tab-content">
            <ag-grid-angular [class.ets-hidden]="selectedTabIndex !== 0"
               class="ag-theme-balham-dark grid" [gridOptions]="positionsGrid"></ag-grid-angular>
            <ag-grid-angular [class.ets-hidden]="selectedTabIndex !== 1"
               class="ag-theme-balham-dark grid" [gridOptions]="ledgerGrid"></ag-grid-angular>
         </div>
         <dx-tabs [dataSource]="tabs" [selectedIndex]="selectedTabIndex" (onItemClick)="selectTab($event)" class="tabs"></dx-tabs>
      </div>
   </as-split-area>

</as-split>
</div>

<!-- Create Portfolio (uniform FORM style: label left, input right) -->
<dx-popup [width]="370" [height]="175" title="Create Portfolio" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="false" [dragEnabled]="false"
   [visible]="portfolioDialog.visible" (onHidden)="closePortfolioDialog()">
   <div *dxTemplate="let data of 'content'" class="collars-dialog qty-dialog form-dialog">
      <div class="form-row">
         <div class="form-label">Portfolio Name</div>
         <dx-text-box class="form-input" placeholder="Enter portfolio name..." [(value)]="portfolioDialog.name"></dx-text-box>
      </div>
      <div class="form-row">
         <div class="form-label">Terminal</div>
         <dx-select-box class="form-input" placeholder="Select terminal..." [dataSource]="availableTerminals"
            [displayExpr]="'userName'" [valueExpr]="'terminalId'" [(value)]="portfolioDialog.terminalId"></dx-select-box>
      </div>
      <div class="buttons">
         <dx-button text="Create" type="success" (onClick)="onCreatePortfolio()"></dx-button>
         <dx-button text="Cancel" (onClick)="closePortfolioDialog()"></dx-button>
      </div>
   </div>
</dx-popup>

<!-- Create Combo -->
<dx-popup [width]="390" [height]="300" title="Create Combo" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="false" [dragEnabled]="false"
   [visible]="comboDialog.visible" (onHidden)="closeComboDialog()">
   <!-- FORM layout (owner ruling 2026-06-10): label left, input right — three unlabeled boxes told the
        operator nothing. -->
   <div *dxTemplate="let data of 'content'" class="collars-dialog qty-dialog form-dialog">
      <div class="form-row">
         <div class="form-label">Combo Name</div>
         <dx-text-box class="form-input" placeholder="Enter combo name..." [(value)]="comboDialog.name"></dx-text-box>
      </div>
      <div class="form-row">
         <div class="form-label">Template</div>
         <dx-select-box class="form-input" [dataSource]="comboTemplates" [displayExpr]="'text'" [valueExpr]="'key'"
            [(value)]="comboDialog.template"></dx-select-box>
      </div>
      <div class="form-row">
         <div class="form-label">Default Qty</div>
         <!-- Mandatory combo parameter (the Make-Transaction totals normalizer). -->
         <dx-number-box class="form-input default-qty" [min]="1" [showSpinButtons]="true"
            [(value)]="comboDialog.defaultQty"></dx-number-box>
      </div>
      <div class="form-row">
         <div class="form-label">Starting Capital</div>
         <dx-number-box class="form-input" [min]="1" [showSpinButtons]="false" format="$#,##0.##" [(value)]="comboDialog.startingCapital"></dx-number-box>
      </div>
      <div class="buttons">
         <dx-button text="Create" type="success" (onClick)="onCreateCombo()"></dx-button>
         <dx-button text="Cancel" (onClick)="closeComboDialog()"></dx-button>
      </div>
   </div>
</dx-popup>

<!-- Combo Settings (context menu "Combo Settings...", CR-20260611-001): Default Qty (the
     Make-Transaction totals normalizer) + auto-expire-at-reset. Backend-persisted on the bucket row
     (replaces the compact per-user Default Qty popup); FORM style like Create Combo. -->
<dx-popup [width]="390" height="auto" title="Combo Settings" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="false" [dragEnabled]="false"
   [visible]="comboSettingsDialog.visible" (onHidden)="closeComboSettingsDialog()">
   <div *dxTemplate="let data of 'content'" class="collars-dialog qty-dialog form-dialog combo-settings-dialog">
      <div class="dialog-hint">{{ comboSettingsDialog.comboName }}</div>
      <div class="form-row">
         <div class="form-label">Default Qty</div>
         <dx-number-box class="form-input default-qty" [min]="1" [showSpinButtons]="true"
            [(value)]="comboSettingsDialog.qty"></dx-number-box>
      </div>
      <div class="form-row">
         <div class="form-label">Starting Capital</div>
         <dx-number-box class="form-input starting-capital" [min]="1" [readOnly]="comboSettingsDialog.hasStartingCapital" [showSpinButtons]="false" format="$#,##0.##" [(value)]="comboSettingsDialog.startingCapital"></dx-number-box>
      </div>
      <div class="form-row">
         <div class="form-label">Auto Expire</div>
         <!-- ON: expired open options in this combo settle automatically at session reset;
              OFF: expiry stays manual ("Settle at Expiry..."). -->
         <dx-check-box class="form-input" text="Settle expired options at session reset"
            [(value)]="comboSettingsDialog.autoExpire"></dx-check-box>
      </div>
      <div class="buttons">
         <dx-button text="Save" type="success" (onClick)="onSaveComboSettings()"></dx-button>
         <dx-button text="Cancel" (onClick)="closeComboSettingsDialog()"></dx-button>
      </div>
   </div>
</dx-popup>

<dx-popup [width]="340" height="auto" [title]="accountCashDialog.kind === 1 ? 'Deposit' : 'Withdrawal'" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="false" [dragEnabled]="false"
   [visible]="accountCashDialog.visible" (onHidden)="closeAccountCashDialog()">
   <div *dxTemplate="let data of 'content'" class="collars-dialog qty-dialog form-dialog account-cash-dialog">
      <div class="form-row">
         <div class="form-label">Amount</div>
         <dx-number-box class="form-input" [min]="0.01" [showSpinButtons]="false" format="$#,##0.##" [(value)]="accountCashDialog.amount"></dx-number-box>
      </div>
      <div class="buttons">
         <dx-button [text]="accountCashDialog.kind === 1 ? 'Deposit' : 'Withdrawal'" type="success" (onClick)="onRecordAccountCash()"></dx-button>
         <dx-button text="Cancel" (onClick)="closeAccountCashDialog()"></dx-button>
      </div>
   </div>
</dx-popup>

<!-- Create Group (uniform FORM style: label left, input right) -->
<dx-popup [width]="370" [height]="140" title="Create Group" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="false" [dragEnabled]="false"
   [visible]="groupDialog.visible" (onHidden)="closeGroupDialog()">
   <div *dxTemplate="let data of 'content'" class="collars-dialog qty-dialog form-dialog">
      <div class="form-row">
         <div class="form-label">Group Name</div>
         <dx-text-box class="form-input" placeholder="Enter group name..." [(value)]="groupDialog.name"></dx-text-box>
      </div>
      <div class="buttons">
         <dx-button text="Create" type="success" (onClick)="onCreateGroup()"></dx-button>
         <dx-button text="Cancel" (onClick)="closeGroupDialog()"></dx-button>
      </div>
   </div>
</dx-popup>

<!-- Move (transfer) a position or a whole group to another bucket (same terminal). Records a matched
     Transfer Out / Transfer In ledger pair. Reuses the interest-dialog label/value layout. -->
<dx-popup [width]="420" [height]="330" [title]="moveDialog.title" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="false" [dragEnabled]="false"
   [visible]="moveDialog.visible" (onHidden)="closeMoveDialog()">
   <div *dxTemplate="let data of 'content'" class="collars-dialog interest-dialog">
      <div class="if-body">
         <fieldset>
            <legend>P&amp;L policy</legend>
            <div class="if-row">
               <div class="if-label">Mode</div>
               <div class="if-value">
                  <dx-select-box [items]="transferModes" displayExpr="text" valueExpr="id"
                     [(value)]="moveDialog.mode"></dx-select-box>
               </div>
            </div>
         </fieldset>

         <fieldset>
            <legend>Target bucket</legend>
            <div class="if-row">
               <div class="if-label">Portfolio</div>
               <div class="if-value">
                  <dx-select-box placeholder="Select portfolio" [items]="moveTargetPortfolios"
                     displayExpr="name" valueExpr="bucketId"
                     [value]="moveDialog.targetPortfolioId" (valueChange)="onMoveTargetPortfolioChange($event)"></dx-select-box>
               </div>
            </div>
            <div class="if-row">
               <div class="if-label">Combo</div>
               <div class="if-value">
                  <dx-select-box placeholder="Select combo" [items]="moveTargetCombos"
                     displayExpr="name" valueExpr="bucketId"
                     [value]="moveDialog.targetComboId" (valueChange)="onMoveTargetComboChange($event)"></dx-select-box>
               </div>
            </div>
            <div class="if-row">
               <div class="if-label">Group</div>
               <div class="if-value">
                  <dx-select-box placeholder="Select group" [items]="moveTargetGroups"
                     displayExpr="name" valueExpr="bucketId" [(value)]="moveDialog.targetGroupId"></dx-select-box>
               </div>
            </div>
         </fieldset>
      </div>

      <div class="buttons">
         <dx-button text="Move" type="success" (onClick)="onMove()"></dx-button>
         <dx-button text="Cancel" (onClick)="closeMoveDialog()"></dx-button>
      </div>
   </div>
</dx-popup>

<!-- Override a position's quantity and/or average price (enter-only, a manual correction). Either field is
     optional — clear a box to leave that value unchanged. Pre-filled with the position's current values. -->
<dx-popup [width]="360" [height]="270" [title]="overrideDialog.title" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="false" [dragEnabled]="true"
   [visible]="overrideDialog.visible" (onHidden)="closeOverrideDialog()">
   <div *dxTemplate="let data of 'content'" class="collars-dialog interest-dialog override-dialog">
      <div class="if-body">
         <div class="if-row">
            <div class="if-label">Symbol</div>
            <div class="if-value">{{ overrideDialog.symbol }}</div>
         </div>
         <div class="if-row">
            <div class="if-label">Avg. Price</div>
            <div class="if-value">
               <dx-number-box [(value)]="overrideDialog.avgPx" [showClearButton]="true"
                  format="$#,##0.####" placeholder="(unchanged)"></dx-number-box>
            </div>
         </div>
         <div class="if-row">
            <div class="if-label">Quantity</div>
            <div class="if-value">
               <dx-number-box [(value)]="overrideDialog.netPosition" [showClearButton]="true"
                  [step]="1" placeholder="(unchanged)"></dx-number-box>
            </div>
         </div>
      </div>

      <div class="buttons">
         <dx-button text="Override" type="success" (onClick)="onOverride()"></dx-button>
         <dx-button text="Cancel" (onClick)="closeOverrideDialog()"></dx-button>
      </div>
   </div>
</dx-popup>

<!-- Settle at Expiry: record an option's expiry outcome (enter-only). Worthless closes the option leg
     only; Assigned (short) / Exercised (long) also spawn the underlying at the strike, netting any held
     asset. Reuses the interest-dialog label/value layout. -->
<dx-popup [width]="500" [height]="440" title="Settle at Expiry" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="false" [dragEnabled]="true"
   [visible]="settleDialog.visible" (onHidden)="closeSettleDialog()">
   <div *dxTemplate="let data of 'content'" class="collars-dialog interest-dialog settle-dialog">
      <div class="if-body">
         <fieldset>
            <legend>Option</legend>
            <div class="if-row">
               <div class="if-label">Contract</div>
               <div class="if-value"><div class="if-static">{{ settleDialog.optionName }}</div></div>
            </div>
            <div class="if-row">
               <div class="if-label">Net position</div>
               <div class="if-value"><div class="if-static">{{ settleDialog.net }}</div></div>
            </div>
         </fieldset>

         <fieldset>
            <legend>Settlement</legend>
            <!-- The UNDERLYING settlement level for the expiration day. Pre-filled from the resolved price
                 (mark/fetch); editable. The outcome below is DERIVED from it — never chosen. -->
            <div class="if-row">
               <div class="if-label">Settlement price</div>
               <div class="if-value">
                  <!-- valueChangeEvent="input": the Settle gate below reads settlementPrice, and the
                       panel view is DETACHED — the handler writes the model and repaints immediately;
                       the preview re-derive stays behind its 400ms debounce. min=0 is load-bearing:
                       a settlement level is never negative, and it closes the mask's minus-on-selection
                       sign flip, which commits through no 'input' event. -->
                  <dx-number-box [(value)]="settleDialog.settlementPrice" [showSpinButtons]="false"
                     valueChangeEvent="input" [min]="0"
                     placeholder="Enter the settlement price" format="$#,##0.##"
                     (onValueChanged)="onSettlementLevelChanged($event)"></dx-number-box>
               </div>
            </div>
            <!-- Price couldn't be resolved: prompt the user to enter it, right below the box. -->
            <div class="if-row" *ngIf="!settleDialog.loading && !settleDialog.levelResolved">
               <div class="if-value"><div class="if-static settle-error">Settlement price could not be retrieved — enter it manually to settle.</div></div>
            </div>

            <div class="if-row" *ngIf="settleDialog.loading">
               <div class="if-label">Settlement price</div>
               <div class="if-value"><dx-load-indicator [height]="20" [width]="20"></dx-load-indicator></div>
            </div>

            <div class="if-row" *ngIf="settleTimeDisplay">
               <div class="if-label">Settles</div>
               <div class="if-value"><div class="if-static">{{ settleTimeDisplay }}</div></div>
            </div>

            <ng-container *ngIf="!settleDialog.loading && settleDialog.levelResolved">
               <div class="if-row">
                  <div class="if-label">Moneyness</div>
                  <div class="if-value"><div class="if-static">{{ settleDialog.moneynessLabel }}<span *ngIf="settleDialog.intrinsic > 0"> · Intrinsic {{ usd(settleDialog.intrinsic) }}</span></div></div>
               </div>
               <!-- The settle's financial result, one short single-line row each (owner 2026-06-15) so nothing
                    wraps under the scrollbar: the outcome type, the premium component, the net realized P&L,
                    and the spawned asset change ("N/A" when nothing spawns — cash-settled or worthless). -->
               <div class="if-row">
                  <div class="if-label">Outcome</div>
                  <div class="if-value"><div class="if-static">{{ settleDialog.outcomeLabel }}</div></div>
               </div>
               <!-- P&L as a breakdown: operation ± premium = total (the net realized result) -->
               <div class="if-row">
                  <div class="if-label">P&amp;L</div>
                  <div class="if-value"><div class="if-static">{{ settlePnlBreakdown() }}</div></div>
               </div>
               <div class="if-row">
                  <div class="if-label">Position</div>
                  <div class="if-value"><div class="if-static">{{ settlePositionChange() }}</div></div>
               </div>
            </ng-container>
         </fieldset>
      </div>

      <div class="buttons">
         <dx-button text="Settle" type="success" [disabled]="settleDialog.loading || settleDialog.settlementPrice == null"
            (onClick)="onSettleExpiry()"></dx-button>
         <dx-button text="Cancel" (onClick)="closeSettleDialog()"></dx-button>
      </div>
   </div>
</dx-popup>

<!-- Manual Interest Charge confirmation (owner request 2026-06-12; restyle same day): window title
     "Please confirm", centered in-window header, then a bare two-row Period/Amount breakdown of the
     BACKEND-previewed charge (whole days since the last charge; one full configured period for a first
     charge). Labels LEFT, values CENTERED (the agreed values-column rule). Confirm (green) / Cancel
     (red). The charge command recomputes at commit; the backend stays the authority. -->
<dx-popup [width]="380" [height]="250" title="Please confirm" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="false" [dragEnabled]="true"
   [visible]="manualChargeDialog.visible" (onHidden)="closeManualChargeDialog()">
   <div *dxTemplate="let data of 'content'" class="collars-dialog manual-charge-dialog">
      <div class="mc-header">Manual Interest Charge</div>
      <div class="mc-row">
         <div class="mc-label">Period</div>
         <div class="mc-value">{{ manualChargeDialog.periodLabel }}</div>
      </div>
      <div class="mc-row">
         <div class="mc-label">Amount</div>
         <div class="mc-value">{{ manualChargeDialog.amountLabel }}</div>
      </div>
      <div class="buttons">
         <dx-button text="Confirm" type="success" (onClick)="onConfirmManualCharge()"></dx-button>
         <dx-button text="Cancel" type="danger" (onClick)="closeManualChargeDialog()"></dx-button>
      </div>
   </div>
</dx-popup>

<!-- Interest Settings (WB-17; redesigned 2026-06-03 + visual pass): formal label-left / value-right
     layout mirroring the ETS interest-calculator input. Rate uses a DevExtreme % mask bound to the
     decimal fraction (8.00% <-> 0.08). Interest is charged by a backend scheduled job — no live ticker.
     Borrowed = 0 stops charging. All Charge-time fields are aligned label+input rows: Country (grouped)
     drives the Timezone list (raw selects, like the ETS reference); time via the shared
     ets-datetime-picker (mode="time", 24h under the hood). -->
<dx-popup [width]="420" [height]="500" title="Interest Settings" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="false" [dragEnabled]="false"
   [visible]="interestDialog.visible" (onHidden)="closeInterestDialog()">
   <div *dxTemplate="let data of 'content'" class="collars-dialog interest-dialog">

      <!-- Body fills the popup; the action row is pinned to the bottom edge (ETS dialog convention). -->
      <div class="if-body">
         <fieldset>
            <legend>Amount &amp; Rate</legend>
            <div class="if-row">
               <div class="if-label">Borrowed amount</div>
               <div class="if-value">
                  <dx-number-box [(value)]="interestDialog.borrowed" [showSpinButtons]="true"
                     [useLargeSpinButtons]="false" format="$#,##0.##"></dx-number-box>
               </div>
            </div>
            <div class="if-row">
               <div class="if-label">% Rate</div>
               <div class="if-value">
                  <dx-number-box [(value)]="interestDialog.rate" [showSpinButtons]="true"
                     [useLargeSpinButtons]="false" [min]="0" [step]="0.0001" format="#0.00%"></dx-number-box>
               </div>
            </div>
            <div class="if-row">
               <div class="if-label">Days in year</div>
               <div class="if-value">
                  <dx-number-box [(value)]="interestDialog.daysInYear" [showSpinButtons]="true"
                     [useLargeSpinButtons]="false" [min]="1" [step]="1" format="#0"></dx-number-box>
               </div>
            </div>
         </fieldset>

         <fieldset>
            <legend>Charge schedule</legend>
            <div class="if-row">
               <div class="if-label">Interval</div>
               <div class="if-value">
                  <!-- Handler instead of a bare banana (Country-select wiring): the 'Day of week' *ngIf
                       below reads this field, and the panel view is DETACHED — without an explicit
                       repaint the row never appears/disappears until some unrelated detectChanges. -->
                  <dx-select-box [items]="chargeIntervals" displayExpr="text" valueExpr="id"
                     [value]="interestDialog.chargeInterval"
                     (valueChange)="onInterestIntervalChange($event)"></dx-select-box>
               </div>
            </div>
            <div class="if-row" *ngIf="interestDialog.chargeInterval === 1">
               <div class="if-label">Day of week</div>
               <div class="if-value">
                  <dx-select-box [items]="weekdays" displayExpr="text" valueExpr="id"
                     placeholder="Day of week" [(value)]="interestDialog.chargeDayOfWeek"></dx-select-box>
               </div>
            </div>
         </fieldset>

         <fieldset>
            <legend>Charge time</legend>
            <div class="if-row">
               <div class="if-label">Country</div>
               <div class="if-value">
                  <dx-select-box placeholder="Select country" [items]="timezoneFamilies" [grouped]="true"
                     displayExpr="displayName" valueExpr="displayName" [showClearButton]="true"
                     [value]="interestDialog.country" (valueChange)="onInterestCountryChange($event)"></dx-select-box>
               </div>
            </div>
            <div class="if-row">
               <div class="if-label">Timezone</div>
               <div class="if-value">
                  <dx-select-box placeholder="Select timezone" [items]="timezoneItems"
                     displayExpr="displayName" valueExpr="nodaTimeZoneId" [showClearButton]="true"
                     [(value)]="interestDialog.timeZoneId"></dx-select-box>
               </div>
            </div>
            <div class="if-row">
               <div class="if-label">Time of day</div>
               <div class="if-value">
                  <ets-datetime-picker mode="time" [(value)]="interestDialog.timeOfDay"></ets-datetime-picker>
               </div>
            </div>
         </fieldset>
      </div>

      <div class="buttons">
         <dx-button text="Save" type="success" (onClick)="onSaveInterest()"></dx-button>
         <dx-button text="Cancel" (onClick)="closeInterestDialog()"></dx-button>
      </div>
   </div>
</dx-popup>

<ets-generic-confirmation-dialog #confd [title]="confirmTitle"></ets-generic-confirmation-dialog>

<!-- Backdate (retro-fill) dialog: a deliberate preview -> confirm flow for past-dated fills (launched from
     the group's "Add RetroFill..." menu). Separate dialog because backdating is a serious recompute. -->
<ets-collars-backdate-dialog></ets-collars-backdate-dialog>

<!-- After State (Collars After State CR): edit a desired end-state in-line, save it per leaf group, or
     direct-commit the derived transaction. -->
<ets-collars-make-transaction-dialog #makeTransactionDialog></ets-collars-make-transaction-dialog>

<!-- Apply the saved end-state: diff vs live, enter actual fills, book, then clear the saved plan. -->
<ets-collars-apply-after-state-dialog #applyAfterStateDialog></ets-collars-apply-after-state-dialog>
<!-- The acquisition window for the pending orders of the Portfolio Hedging Analysis (CR-20260930-001 M3). -->
<ets-collars-acquire-dialog></ets-collars-acquire-dialog>
